import { useEffect, useState, type ReactNode } from 'react';

export function usePath(): string {
  const [path, setPath] = useState(location.pathname);
  useEffect(() => {
    const onChange = () => setPath(location.pathname);
    window.addEventListener('popstate', onChange);
    window.addEventListener('navigate', onChange as EventListener);
    return () => {
      window.removeEventListener('popstate', onChange);
      window.removeEventListener('navigate', onChange as EventListener);
    };
  }, []);
  return path;
}

export function navigate(to: string): void {
  if (location.pathname + location.search === to) return;
  history.pushState({}, '', to);
  window.dispatchEvent(new Event('navigate'));
}

export function Link({ to, children }: { to: string; children: ReactNode }) {
  const path = usePath();
  return (
    <a
      href={to}
      aria-current={path === to.split('?')[0] ? 'page' : undefined}
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        navigate(to);
      }}
    >
      {children}
    </a>
  );
}
